import { createStore } from 'react-contextual'

import WishlistService from '../services/Wishlist'

export default createStore({
  wishlistCount: 0,
  fetchWishlistCount: (isLoggedIn) => WishlistService(isLoggedIn).then(({ wishlistCount }) => ({ wishlistCount })),
})
